import { render, staticRenderFns } from "./ViolationRulesAlert.vue?vue&type=template&id=0ecfcb0c&"
import script from "./ViolationRulesAlert.vue?vue&type=script&lang=js&"
export * from "./ViolationRulesAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports